import { Navigate, Outlet } from "react-router-dom";
import { useSelector } from "react-redux";
import ForbiddenScreen from "../screens/ForbiddenScreen";
import { isAdminUser } from "../utils/authz";

const AdminRoute = () => {
  const { userInfo } = useSelector((state) => state.auth);
  // ยังไม่ล็อกอิน → ไป login. ล็อกอินแล้วแต่สิทธิ์ไม่พอ → 403 (ไม่ใช่เด้งไป login)
  if (!userInfo) return <Navigate to="/login" replace />;
  // นิยาม "แอดมิน" ย้ายไปอยู่ที่ utils/authz.js ที่เดียวแล้ว — เดิมไฟล์นี้
  // กับ usePermission และ navCatalog เขียนกันคนละแบบ ทำให้คนแผนก EXEC
  // ผ่านด่านเข้าหน้าได้แต่ปุ่มในหน้าหายหมด
  const isAdmin = isAdminUser(userInfo);

  if (!isAdmin) return <ForbiddenScreen required="admin" />;
  return <Outlet />;
};
export default AdminRoute;
